import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "./authServices";

const getUserfromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;
const initialState = {
  user: getUserfromLocalStorage,
  orders: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  otpSent: false,
  otpVerified: false,
  resetSuccess: false,
};
export const login = createAsyncThunk(
  "auth/login",
  async (userData, thunkAPI) => {
    try {
      return await authService.login(userData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getOrders = createAsyncThunk(
  "order/get-orders",
  async (thunkAPI) => {
    try {
      return await authService.getOrders();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getOrderByUser = createAsyncThunk(
  "order/get-order",
  async (id, thunkAPI) => {
    try {
      return await authService.getOrder(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const sendOtp = createAsyncThunk(
  "auth/send-otp",
  async (email, thunkAPI) => {
    try {
      return await authService.sendOtp(email);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data?.message || "Failed to send OTP");
    }
  }
);

export const verifyOtpOnly = createAsyncThunk(
  "auth/verify-otp-only",
  async (data, thunkAPI) => {
    try {
      return await authService.verifyOtpOnly(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data?.message || "OTP verification failed");
    }
  }
);

export const verifyOtpReset = createAsyncThunk(
  "auth/verify-otp-reset",
  async (data, thunkAPI) => {
    try {
      return await authService.verifyOtpReset(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data?.message || "OTP verification failed");
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {},
  extraReducers: (buildeer) => {
    buildeer
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.message = "success";
      })
      .addCase(login.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(getOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.orders = action.payload;
        state.message = "success";
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(getOrderByUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrderByUser.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.orderbyuser = action.payload;
        state.message = "success";
      })
      .addCase(getOrderByUser.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(sendOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendOtp.fulfilled, (state) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.otpSent = true;
        state.message = "success";
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.otpSent = false;
        state.message = action.payload;
        state.isLoading = false;
      })
      .addCase(verifyOtpReset.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyOtpReset.fulfilled, (state) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.otpVerified = true;
        state.resetSuccess = true;
        state.message = "success";
      })
      .addCase(verifyOtpReset.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.otpVerified = false;
        state.resetSuccess = false;
        state.message = action.payload;
        state.isLoading = false;
      })
      .addCase(verifyOtpOnly.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyOtpOnly.fulfilled, (state) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.otpVerified = true;
        state.message = "success";
      })
      .addCase(verifyOtpOnly.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.otpVerified = false;
        state.message = action.payload;
        state.isLoading = false;
      });
  },
});

export default authSlice.reducer;
